import styled from 'styled-components';

export const DistributorRoot = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 540px;
    max-height: calc(100vh - 220px);
    background: linear-gradient(180deg, #12151c 0%, #1b2030 45%, #12151c 100%);
    border-radius: 8px;
    overflow: hidden;
`;

export const DistributorHint = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin: 12px 12px 0;
    padding: 12px 16px;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.1);
    color: rgba(255, 255, 255, 0.92);
    font-size: 14px;
    line-height: 1.4;

    .hint-text {
        margin: 0;
    }

    .hint-count {
        flex-shrink: 0;
        padding: 6px 12px;
        border-radius: 999px;
        background: ${props => props.theme.palette.primary.main};
        color: #fff;
        font-size: 13px;
        font-weight: 700;
        letter-spacing: 0.02em;
    }
`;

export const MapViewport = styled.div`
    flex: 1;
    min-height: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    overflow: auto;
`;

export const MapStage = styled.div`
    position: relative;
    display: inline-block;
    max-width: 100%;
    max-height: 100%;
    line-height: 0;
    user-select: none;
    border-radius: 12px;
    overflow: visible;
    background: #0d1017;
    box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.08),
        0 18px 48px rgba(0, 0, 0, 0.55);

    img {
        display: block;
        max-width: 100%;
        max-height: calc(100vh - 320px);
        width: auto;
        height: auto;
        border-radius: 12px;
        pointer-events: none;
    }
`;

export const Pin = styled.button`
    position: absolute;
    left: ${props => props.$x}%;
    top: ${props => props.$y}%;
    transform: translate(-50%, -100%)
        scale(${props => (props.$dragging ? 1.08 : 1)});
    border: 0;
    background: transparent;
    padding: 0;
    cursor: ${props => (props.$dragging ? 'grabbing' : 'grab')};
    z-index: ${props => (props.$dragging ? 5 : 2)};
    display: flex;
    flex-direction: column;
    align-items: center;
    outline: none;
    transition: transform 0.12s ease;

    .pin-label {
        margin-bottom: 6px;
        padding: 8px 14px;
        border-radius: 8px;
        background: rgba(10, 12, 18, 0.92);
        border: 1px solid rgba(255, 255, 255, 0.22);
        box-shadow: 0 6px 18px rgba(0, 0, 0, 0.45);
        color: #fff;
        font-size: 18px;
        font-weight: 700;
        line-height: 1.2;
        letter-spacing: 0.01em;
        white-space: nowrap;
        max-width: 260px;
        overflow: hidden;
        text-overflow: ellipsis;
        pointer-events: none;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.55);
    }

    .pin-icon {
        color: ${props =>
            props.$dragging
                ? props.theme.palette.secondary.main
                : props.theme.palette.primary.main};
        filter: drop-shadow(0 0 2px rgba(255, 255, 255, 0.85))
            drop-shadow(0 4px 8px rgba(0, 0, 0, 0.65));
        pointer-events: none;
    }

    &:hover {
        z-index: 4;
        transform: translate(-50%, -100%) scale(1.06);
    }

    &:hover .pin-icon {
        color: ${props => props.theme.palette.secondary.main};
    }

    &:focus-visible .pin-label {
        outline: 2px solid ${props => props.theme.palette.primary.light};
        outline-offset: 2px;
    }
`;
